import { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import ddt from '@wix/da-ddt';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { restrictLoggedOut } from '../../../redux/loggedout';
import { focusEditor as focusEditorNew } from '../../../CommentEditor/redux/actionCreators';
import { useVerification } from '../../../VerificationPopup/withVerification';
import { generateReplyEditorId } from '../../utils';
import { CommentContext } from '../../CommentContext';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import { BiData } from '@wix/da-bi/pkg/events';
const getReplyToParam = ()=>{
    if (typeof window === 'undefined') {
        return;
    }
    // eslint-disable-next-line @wix/da/window-object-typeof-check
    if (!window.location.search) {
        return;
    }
    // eslint-disable-next-line @wix/da/window-object-typeof-check
    const params = new URLSearchParams(window.location.search);
    const replyTo = Number(params.get('reply_to'));
    return replyTo;
};
export function useReplyButtonBase({ onClick, disabledOverride } = {}) {
    const dispatch = useDispatch();
    const { isLoggedIn } = useContext(SessionContext);
    const { comment, isReplying, setEditingState, isReduxReady } = useContext(CommentContext);
    const { restrictToVerified } = useVerification();
    const logBiEvent = useBiLogger();
    const handleClickInner = useCallback(()=>{
        yieldToMain(()=>{
            if (!isLoggedIn) {
                dispatch(restrictLoggedOut({
                    restrictedActionName: ReferralType.COMMENT
                }));
                return;
            }
            if (!isReplying) {
                // if arrived with reply_to param, we already logged this event in the trigger
                const withBiEvent = !getReplyToParam();
                if (withBiEvent) {
                    var _comment_user;
                    logBiEvent(BiData({
                        evid: 181,
                        commenterid: (_comment_user = comment.user) === null || _comment_user === void 0 ? void 0 : _comment_user.useridUuid,
                        commentid: comment.commentId,
                        typeid: comment.typeId,
                        itemid: comment.itemId
                    }));
                }
            }
            ddt.log('comments', 'Replying on comment, editorId: ', generateReplyEditorId(comment));
            setEditingState(isReplying ? 'none' : 'replying');
            dispatch(focusEditorNew(generateReplyEditorId(comment)));
            onClick && onClick();
        });
    }, [
        dispatch,
        logBiEvent,
        isReplying,
        isLoggedIn,
        setEditingState,
        comment,
        onClick
    ]);
    const handleClick = restrictToVerified('comment', handleClickInner);
    return {
        /**
     * Handles all the necessary logic for opening a reply box under a comment.
     *
     * - Restriction to logged in users
     * - Restriction to verified users
     * - Logging
     * - Setting the correct state on the CommentContext to expand the reply comment box
     * - Focusing the editor after it's expanded
     */ onClick: handleClick,
        /**
     * Returns `true` if redux isn't ready
     *
     * Can be overridden with the `disabledOverride` option
     */ disabled: disabledOverride !== null && disabledOverride !== void 0 ? disabledOverride : !isReduxReady
    };
}

//# sourceMappingURL=useReplyButtonBase.js.map